<template>
  <div class="top">
    <div class="top__container">
      <RouterLink to="/" class="top__logo">
        <img src="@/assets/img/ui/top/logo.svg" width="auto" height="32" alt="logo_noofen" />
      </RouterLink>

      <a
        href="https://olpha.eu/en/"
        target="_blank"
        rel="noopener noreferrer"
        class="top__link"
      >
        <img
          class="bottom__logo"
          src="@/assets/img/ui/bottom/logo.svg"
          width="41"
          height="40"
          alt="logo-olainFarm"
        />
      </a>
    </div>
  </div>
</template>

<style scoped lang="scss">
.top {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 300;
  background: var(--Green_1, #42ad76);

  &__container {
    margin: 0 auto;
    max-width: 1440px;
    padding: 20px 60px;

    display: flex;
    justify-content: center;
    align-items: center;

    height: 80px;

    @media screen and (max-width: 1024px) {
      padding: 12px 20px;
      height: 60px;
    }
  }

  &__logo {
    margin-right: auto;

    img {
      width: auto;
      height: 32px;
    }
  }

  &__link {
    img {
      width: auto;
      height: 40px;
    }
  }
}
</style>
